import { useEffect, useState } from 'react';

import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'components/ui/dialog';
import type { YardGateEntry } from '../../adapter';
import * as S from '../../styles';

export const YARD_GATE_OBSERVATION_REQUIRED_ERROR = 'Informe a anotação.';
const YARD_GATE_OBSERVATION_MAX_LENGTH_ERROR =
  'A anotação deve ter no máximo 500 caracteres.';

interface ObservationModalProps {
  entry: YardGateEntry;
  isBusy: boolean;
  onClose: () => void;
  onSubmit: (entry: YardGateEntry, observation: string) => Promise<boolean>;
}

export const ObservationModal = ({
  entry,
  isBusy,
  onClose,
  onSubmit,
}: ObservationModalProps) => {
  const [value, setValue] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    setValue(entry.annotation);
    setError('');
  }, [entry.id, entry.annotation]);

  const save = async () => {
    if (isBusy) return;
    const trimmed = value.trim();
    if (!trimmed) {
      setError(YARD_GATE_OBSERVATION_REQUIRED_ERROR);
      return;
    }
    if (trimmed.length > 500) {
      setError(YARD_GATE_OBSERVATION_MAX_LENGTH_ERROR);
      return;
    }
    const saved = await onSubmit(entry, trimmed);
    if (saved) onClose();
  };

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        aria-describedby={undefined}
        className="bg-white sm:max-w-[480px]"
      >
        <DialogHeader>
          <DialogTitle>Adicionar anotação</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <S.Field>
            <S.Label htmlFor={`observation-modal-${entry.id}`}>
              Anotação
            </S.Label>
            <S.Textarea
              id={`observation-modal-${entry.id}`}
              aria-label={`Anotação de ${entry.plate}`}
              aria-describedby={
                error ? `observation-modal-${entry.id}-error` : undefined
              }
              maxLength={500}
              disabled={isBusy}
              value={value}
              onChange={(event) => {
                setValue(event.target.value);
                setError('');
              }}
            />
            {error ? (
              <S.FieldError id={`observation-modal-${entry.id}-error`}>
                {error}
              </S.FieldError>
            ) : null}
          </S.Field>
          <DialogFooter>
            <S.Button
              mood="light"
              type="button"
              onClick={onClose}
              disabled={isBusy}
            >
              Cancelar
            </S.Button>
            <S.Button type="button" onClick={save} disabled={isBusy}>
              Salvar
            </S.Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
};
